

// const assignmentSaabItem1 = "Designade och implementerade en applikation för ett nyutvecklat SBC-kort i ett radarsystem, för att motionera samtliga externa gränssnitt i en kritisk hårdvaruverifieringsprocess med hjälp av VxWorks och C++ 17.\n";
// const assignmentSaabItem2 = "Uppgraderade betydliga delar av HAL för det aktuella SBC-kortet, inklusive timers, flash IO, diskret IO och seriell kommunikation.";
// const assignmentSaabItem3 = "Designade och implementerade en helt ny mjukvara för radarsystemet som tillåter användare att uppdatera olika programvaror såsom Uboot, radarmjukvaran och diverse konfigurationsfiler.\n";
// const assignmentSaabItem4 = "Utvecklade en simulatorprogramvara för SBC-kortet som tillåter olika team att utveckla och testa radarvarningssystemet i sin helhet.";
// const assignmentSaabItem5 = "Implementerade en avancerad laddningsprocedur över MIL-STD-1553 för radarvarnare.\n";
// const assignmentSaabItem6 = "Utförde system och unit tester för samtliga listade delar ovan i nära samarbete med integration & testavdelningen.";

const assignmentSaabItem1 = "Engineered a realtime application for hardware verification of new SBC for aircraft radarsystem. Based on C++ and VxWorks.";
const assignmentSaabItem2 = "Uplifted significant parts of HAL for said SBC, involved uplifted OS, C++ version.";
const assignmentSaabItem3 = "Designed and developed a completely new softwareloader for the radarsystem. Enabled flashing of Uboot and radar application."
const assignmentSaabItem4 = "Architected a new passthrough application for the radar system to allow testing and verification by external systems.";
const assignmentSaabItem5 = "Uplifted the radar system's MIL-STD-1553 loading procedure to accommodate the new hardware.";
const assignmentSaabItem6 = "Executed system and unit tests of the radar hardware in close cooperation with testing and verification department.";


const assignmentSaabSkill = ['C/C++', 'Python', 'VxWorks', 'UBOOT', 'Linux','MIL1553']

const AssignmentSaab = {
    desc: [
        assignmentSaabItem1,
        assignmentSaabItem2,
        //assignmentSaabItem3,
        //assignmentSaabItem4,
        //assignmentSaabItem5,
        //assignmentSaabItem6,
    ],
    skill: assignmentSaabSkill,
};

export default AssignmentSaab;




